module.exports = __webpack_public_path__ + "static/media/sign.1c78e8aa.svg";